<template>
    <div>
        <!-- Manufacturer sales net amount -->
        <div
            v-if="manufacturerSalesNet !== null"
            class="retr-current__condition-group"
        >
            <retr-current-condition-item
                :condition="{
                    condition_name: 'Wartość obrotu',
                    retro: manufacturerSalesNet
                }"
                :show-value-percentage="false"
            />
        </div>

        <!-- Condition groups -->
        <retr-current-condition-group
            v-for="(conditionGroup, conditionGroupIndex) in sortedConditionGroups"
            :key="`conditionGroup-${conditionGroupIndex}`"
            :condition-group="conditionGroup"
            :manufacturer-name="manufacturer.manufacturer_name ?? ''"
        />
    </div>
</template>

<script>
import RetrCurrentConditionGroup from './RetrCurrentConditionGroup.vue'
import RetrCurrentConditionItem from './RetrCurrentConditionItem.vue'
import { sortConditionGroupsByOrder } from '@/helpers/retr'

export default {
    name: 'RetrCurrentManufacturerContent',
    components: {
        RetrCurrentConditionGroup,
        RetrCurrentConditionItem
    },
    props: {
        manufacturer: {
            type: Object,
            required: true
        },
        manufacturerSalesNet: {
            type: Number,
            default: null,
            validator: (value) => value === null || typeof value === 'number'
        }
    },
    computed: {
        sortedConditionGroups() {
            return sortConditionGroupsByOrder(this.manufacturer.list)
        }
    }
}
</script>
